import { z } from 'zod'

import { dbEntitySchema } from './system'

export const prospectSchema = dbEntitySchema.extend({
  firstName: z.string().nullish(),
  lastName: z.string().nullish(),
  phone: z.string().nullish(),
  email: z.string().nullish(),
  guid: z.string().nullish(),
  client: z.string().nullish(),
  name: z.string().nullish(),
  birthday: z.date().nullish(),
  user: z.string().nullish(),
  marketingOptIn: z.boolean().nullish(),
  marketingOptInSignature: z.string().nullish(),
  administrativeArea: z.string().nullish(),
})

/** Allowed v0 prospect profile update fields (extras stripped server-side). */
export const prospectUpdateInputSchema = z
  .object({
    name: z.string().nullish(),
    firstName: z.string().nullish(),
    lastName: z.string().nullish(),
    phone: z.string().nullish(),
    email: z.string().nullish(),
    birthday: z.coerce.date().nullish(),
  })
  .partial()

export type ProspectUpdateInput = z.infer<typeof prospectUpdateInputSchema>
